import type { Company } from '@/api/company.service';
import { useNotification } from '@/context/NotificationContext';
import { TransferList } from '@/components/TransferList';

type CompanyTransferListParams = {
  usableCompanies: Company[],
  values: any,
  setValues: any,
}

export default function CompanyTransferList({ usableCompanies, values, setValues }: CompanyTransferListParams) {
  const { notify } = useNotification();
  const companiesList: string[] = values.companies ?? [];

  return (
    <TransferList<Company>
      items={usableCompanies}
      selectedIds={companiesList}
      onChange={(companies) => setValues({ ...values, companies })}
      getId={(c) => c.id}
      getLabel={(c) => c.name}
      leftTitle="Disponíveis"
      rightTitle="Vinculadas"
      itemNoun="empresa(s)"
      searchPlaceholder="Filtrar empresas..."
      onMoveRight={() => notify("Empresas vinculadas", "success")}
      onMoveLeft={() => notify("Vínculos removidos", "info")}
    />
  );
}
